module.exports = __webpack_public_path__ + "static/media/fly0196.a497b47f.webp";